"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var enjoyMore = function enjoyMore(list, t) {
  if (!(list !== null && list !== void 0 && list.length)) return;
  var limit = 4;
  var isListGreaterThanLimit = list.length > limit;
  var remaining = list.length - limit;
  var visibleItems = isListGreaterThanLimit ? list.slice(0, limit) : list;
  var imageBaseUrl = 'https://cmsstg-dros-config.s3-eu-west-1.amazonaws.com/plans';
  return {
    extraServices: isListGreaterThanLimit && remaining,
    extraServicesText: isListGreaterThanLimit && t('more'),
    fallBackImage: "".concat(imageBaseUrl, "/apps.png"),
    icons: visibleItems.map(function (item) {
      return {
        name: item === null || item === void 0 ? void 0 : item.name,
        url: item.img || // eslint-disable-next-line max-len
        "".concat(imageBaseUrl, "/").concat(item === null || item === void 0 ? void 0 : item.icon.replace(/\+/g, '%2B').toLowerCase(), ".png")
      };
    })
  };
};
var _default = enjoyMore;
exports.default = _default;